define('project/Validate',[
    'jquery',
    'project/MbiConfig',
    'base/MbiMediaQuery',
    'base/MbiHelper',
    // 'project/Login',
    'validate',
    'tooltipster'
], function(
    $,
    mbiConfig,
    mbiMq,
    _
    // validation
) {
    'use strict';
    var module = {
    // ---------------------------------------------------------------
    // VALIDATE CHECKOUT FORM 1
    // ---------------------------------------------------------------
    language: 'de',
    validateForm: function(form) {

        var messages = {
            de: {
                required: "Pflichtfeld",
                email: "Bitte geben Sie eine gültige Email an",
                uid: "Bitte geben Sie eine gültige UID an",
                phone: "Bitte geben Sie eine gültige Telefonnummer an ",
                equal: "Das Passwort stimmt nicht überein"
            },
            en: {
                required: "Required",
                email: "Please insert a valid email address.",
                uid: "Please insert a valid VAT number.",
                phone: "Please insert a valid phone number",
                equal: "Password does not match"
            },
            it: {
                required: "Obbligatori",
                email: "Inserisci una email valida",
                uid: "Inserisci una partita IVA valida",
                phone: "Inserisci uno numero valida",
                equal: "la password non corrisponde"
            },
            fr: {
                required: "Obligatoire",
                email: "Merci d’indiquer une email valide",
                uid: "Merci d’indiquer un numéro de TVA valide",
                phone: "Merci d’indiquer un numéro valide",
                equal: "le mot de passe ne correspond pas"
            },
            es: {
                required: "Necesario",
                email: "Por favor, introduzca un email válido",
                uid: "Por favor, introduzca un número de CIF válido",
                phone: "Por favor, introduzca un número válido",
                equal: "las contraseñas no coinciden"
            }
        }
        $.extend($.validator.messages, {
                required: messages[module.language].required,
                email: messages[module.language].email,
                checkout1__uid: messages[module.language].uid,
                phone: messages[module.language].phone,
                equalTo: messages[module.language].equal
        });

        $.validator.addMethod("validPhone", function(value, element) {
          // allow any non-whitespace characters as the host part
              return this.optional( element ) || /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/.test( value );
        }, $.validator.messages.phone);

            /*
                CHANGED TOOLTIPSTER ON LINE 350!!!!!! CARE BEFORE UPDATEING
            */

        $('input[type="text"]').tooltipster({
            trigger: 'custom', // default is 'hover' which is no good here
            onlyOne: false,    // allow multiple tips to be open at a time
            // timer: 3000,
            position: 'left',  // display the tips to the right of the element
            offsetY: 0,
            theme: 'custom-tooltipster'
        });
        // $('input').tooltipster('update', 'WOS IS');
        // $('input').tooltipster('show');
        $('#anfrageform').validate({
            rules: {
                required: true,
                phone: {
                    validPhone:true
                },
                email: {
                    email: true
                }
            },
            errorPlacement: function(error, element) {
                $(element).tooltipster('update', $(error).text());
                $(element).tooltipster('show');
                $(element).parent().addClass('error');
            },
            success: function (label, element) {
                $(element).tooltipster('hide');
                $(element).parent().removeClass('error');
            },
            onfocusout: false,
            onkeyup: false
        });

    }
}
return module;
});
